#import "./cartFragment.gql"

mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $id: ID!, $lang: LanguageCode!)
@inContext(language: $lang) {
  cartAttributesUpdate(attributes: $attributes, cartId: $id) {
    cart {
      ...cartFragment
    }
    userErrors {
      field
      message
    }
  }
}
